import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { isEmpty } from 'lodash';

import { IndustryCatalogFilter } from '@mp/content-manager/industriekataloge/data-access';
import { QueryParamsFilterConverterInterface } from '@mp/shared/data-access';

@Injectable()
export class IndustriekatalogeQueryParamsFilterConverter
  implements QueryParamsFilterConverterInterface<IndustryCatalogFilter>
{
  convertToQueryParams(filter: Partial<IndustryCatalogFilter>): Params {
    return {
      sort: filter.sortCriteria,
      page: filter.page,
      pageSize: filter.pageSize,
      search: filter.searchTerm !== '' ? filter.searchTerm : undefined,
      openTasks: !isEmpty(filter.openTasks) ? filter.openTasks?.join(',') : undefined,
      datasources: !isEmpty(filter.datasources) ? filter.datasources?.join(',') : undefined,
    };
  }

  convertFromQueryParams(queryParams: Params): IndustryCatalogFilter {
    return {
      page: parseInt(queryParams['page'] || 1),
      pageSize: parseInt(queryParams['pageSize'] || 50),
      sortCriteria: queryParams['sort'],
      searchTerm: queryParams['search'] || '',
      openTasks: queryParams['openTasks'] ? queryParams['openTasks'].split(',') : undefined,
      datasources: queryParams['datasources'] ? queryParams['datasources'].split(',') : undefined,
    };
  }
}
